var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageInWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5013 16.3333L23.0013 12.8333H14.8346C14.5252 12.8333 14.2285 12.7104 14.0097 12.4916C13.7909 12.2728 13.668 11.9761 13.668 11.6667V4.66667C13.668 4.35725 13.7909 4.0605 14.0097 3.84171C14.2285 3.62292 14.5252 3.5 14.8346 3.5H25.3346C25.6441 3.5 25.9408 3.62292 26.1596 3.84171C26.3784 4.0605 26.5013 4.35725 26.5013 4.66667V16.3333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 17.5003V19.8337C18.3333 20.1431 18.2104 20.4398 17.9916 20.6586C17.7728 20.8774 17.4761 21.0003 17.1667 21.0003H9L5.5 24.5003V12.8337C5.5 12.5242 5.62292 12.2275 5.84171 12.0087C6.0605 11.7899 6.35725 11.667 6.66667 11.667H9",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.410156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInWhite);
export default __webpack_public_path__ + "static/media/messageInWhite.f3952e5cfa4bddbacba246c293e54b18.svg";
export { ForwardRef as ReactComponent };